
import { IEmployerBalancesState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { ResponseAction } from './actions';

export const state: IEmployerBalancesState = {
  data: []
};

const reducer = createReducer(state,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      data: payload
    };
  })
);

export function employerBalancesReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
